import React from 'react';
import { GuideStats } from './components/GuideStats';
import { RecentPilgrims } from './components/RecentPilgrims';
import { useDashboardData } from './hooks/useDashboardData';
import { useGuideStats } from './hooks/useStats';
import { useUserVerification } from '../../hooks/useUserVerification';
import { ContractViewer } from '../../components/contracts/ContractViewer';
import { LoadingSpinner } from '../../components/common/LoadingSpinner';
import { FileText } from 'lucide-react';

export const GuideDashboard = () => {
  const userId = localStorage.getItem('userId') || '';
  
  // Get user verification data
  const { verification: userVerification, loading: verificationLoading } = useUserVerification(userId);
  
  // Initialize real-time data
  useDashboardData(false);
  const { stats, loading } = useGuideStats(userId);

  if (loading || verificationLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="space-y-6">
      {/* Contract Section - Only show if verification is approved and has a contract */}
      {userVerification && userVerification.status === 'approved' && userVerification.contractUrl && (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-green-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-green-50 rounded-lg">
                <FileText className="text-green-500" size={24} />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900">Your Contract</h2>
                <p className="text-sm text-gray-500">View the contract you signed</p>
              </div>
            </div>
            <ContractViewer
              contractUrl={userVerification.contractUrl}
              title="View Contract"
              className="px-4 py-2"
            />
          </div>
        </div>
      )}
      
      <GuideStats stats={stats} />
      <RecentPilgrims pilgrims={stats.recentPilgrims} />
    </div>
  );
};
